import classes from 'classnames';
import styles from './Heading.module.scss';

export type HeadingProps = {
  className?: string;
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  text: string;
  weight?: 'regular' | 'medium' | 'semibold' | 'bold';
};

export default function Heading({
  className,
  level: Tag = 'h1',
  text,
  weight = 'regular',
}: HeadingProps) {
  return (
    <Tag className={classes(styles[`weight-${weight}`], className)}>{text}</Tag>
  );
}
